
export function setInfoValue(attributeID, innerHtml) {
    document.querySelectorAll('form-element').forEach(formElement => {
        if(formElement.dataset.id === attributeID) {
            if(formElement.dataset.attributeTypeId === 'null') {
                formElement.getElementsByClassName('preview-value')[0].innerHTML = innerHtml
            }
        }
    })
}

export function replaceStringValue(searchValue, innerHtml) {
    document.querySelectorAll('form-element').forEach(formElement => {
        const element = formElement.querySelectorAll('input')
        if(element.length > 0) {
            element.forEach(item => {
                if(!innerHtml) {
                    innerHtml = ''
                }
                item.value = item.value.replace(searchValue, innerHtml)
            })
        }
    })
}

export function replaceMeteoValue(meteoValues) {
    document.querySelectorAll('form-element').forEach(formElement => {
        const element = formElement.querySelectorAll('input')
        if(element.length > 0) {
            let value = formElement.dataset.defaultValue

            if(value.includes('$meteo')) {
                element.forEach(item => {
                    for (const [key, meteoValue] of Object.entries(meteoValues)) {
                        item.value = item.value.replace('$meteo_' + key, meteoValue)
                    }
                })
            }
        }
    })
}

export function hasReplaceStringAttributes(attribute) {
    let hasMeteo = false
    window.wizard.Items.map(item => {
        item.Items.map(childItem => {
            if(childItem.DefaultValue !== undefined && childItem.DefaultValue !== null) {
                if(String(childItem.DefaultValue).includes('$' + attribute)) {
                    hasMeteo = true
                }
            }
        })
    })
    return hasMeteo
}
